/**
 * 运行期配置读取
 *
 * 优先级（高 → 低）：
 *   1) window.__MP_CONFIG__（部署后热改，运营改下载地址 / 统计开关无需重新发版）
 *   2) 构建期注入的 __RUNTIME_CONFIG__（见 build/env.js + webpack DefinePlugin / vite define）
 *
 * 用法：
 *   const { appName, download, trackEnabled } = getRuntimeConfig()
 */

function readBuildConfig(): RuntimeConfig {
  // __RUNTIME_CONFIG__ 由构建工具注入，TS 通过 global.d.ts 识别类型
  return __RUNTIME_CONFIG__
}

let cache: RuntimeConfig | null = null

export function getRuntimeConfig(): RuntimeConfig {
  if (cache) return cache

  const build = readBuildConfig()
  const override =
    typeof window !== "undefined" && window.__MP_CONFIG__
      ? window.__MP_CONFIG__
      : undefined

  cache = { ...build, ...(override ?? {}) }
  return cache
}

/** 仅用于在测试 / SSR 场景下重置缓存 */
export function resetRuntimeConfig(): void {
  cache = null
}

// RuntimeConfig 类型为全局声明（见 src/shared/types/global.d.ts），无需从本模块导出
